<script>
import { mapState } from 'vuex';
import { get, orderBy } from 'lodash';
import base from '@/views/config/addon-cards/templates/base.vue';
import { planTypes } from '@/common/constants';
import planCommon from './mixin';

export default {
  name: 'CustomAvatarsAddon',
  mixins: [base, planCommon],
  for: () => {
    return planTypes.map([ planTypes.ZOOM_CLIPS ]);
  },
  data() {
    return {
      planType: planTypes.CUSTOM_AVATARS,
      description: this.$t('billing.custom_avatars.addon.desc'),
    }
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return orderBy(
        this.planMapFlat.filter((p) => p.type === this.planType),
        ['amount'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
